/**
 * Public film copy only. No provider call is made by this editorial fallback.
 * These are screened without knowing the game, so each must be true of ANY game:
 * no feet, music, cast, speed or choice the game may not have. There must be at
 * least as many as a sealed film has scenes, since a film never repeats one.
 */
export const CREATION_FILM_FALLBACK_CAPTIONS = [
  'Something good is brewing', 'A tiny spark takes off', 'This could get wild', 'Looking sharp already',
  'A world wakes up', 'Follow that little hunch', 'Every piece finds a place', 'One more clever twist',
  'That looks like trouble', 'Ready for a little chaos', 'Oops becomes aha', 'A small surprise sneaks in',
  'Somebody brought the sparkle', 'Take it for a spin', 'Adventure has entered the room', 'Your turn to shine',
  'Go make some mischief', 'Just one more round', 'A fresh twist awaits', 'Let the fun loose',
  'Here comes the good part', 'Now it feels like a game',
] as const;

export function normalizeCreationFilmCaption(value: string): string {
  return value.normalize('NFKC').toLowerCase().replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
}

export function publicCreationFilmCaption(value: string): string | undefined {
  const clean = value.trim().replace(/\s+/g, ' ');
  if (!clean || clean.length > 80 || clean.split(' ').length > 8
    || /\b(?:pipeline|demo|artifact|asset|png|jpe?g|webp|file|format|renderer?|workflow|quality gate|build step|provider|model|proof|test|creation film)\b/i.test(clean)) return undefined;
  return clean;
}
